import { render, staticRenderFns } from "./SacReportCallsQuantity.vue?vue&type=template&id=5fec7488&scoped=true&"
import script from "./SacReportCallsQuantity.vue?vue&type=script&lang=js&"
export * from "./SacReportCallsQuantity.vue?vue&type=script&lang=js&"
import style0 from "./SacReportCallsQuantity.vue?vue&type=style&index=0&id=5fec7488&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fec7488",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/_work/studio/studio/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VRow } from 'vuetify/lib'
installComponents(component, {VCol,VDataTable,VRow})
